import { render, staticRenderFns } from "./SendDialog.vue?vue&type=template&id=34a94a54&scoped=true&"
import script from "./SendDialog.vue?vue&type=script&lang=js&"
export * from "./SendDialog.vue?vue&type=script&lang=js&"
import style0 from "./SendDialog.vue?vue&type=style&index=0&id=34a94a54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a94a54",
  null
  
)

export default component.exports